module.exports = __webpack_public_path__ + "media/images/gallery/constellations/rn_layer_off-2e2fe3ebf21fbf853efa064a27dfb4fb.png";